import React from "react";
import { Link } from "react-router-dom";
import { domain } from "../../ajax/Ajax";
import { Loading } from "../../App";
import logo from "../../images/logo.png";
import { Helmet } from "react-helmet/es/Helmet";
import Ajax from "../ajax/Ajax";

class AddStock extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      qtyAdded: "",
      stockAddSuccessful: false,
      stockAddFailed: false,
      processing: false,
    };

    this.saveStockAdded = this.saveStockAdded.bind(this);
    this.closeModal = this.closeModal.bind(this);

    this.qtyAddedInput = React.createRef();
    this.closeAddStockModalBtn = React.createRef();
  }

  closeModal() {
    this.closeAddStockModalBtn.current.click();
  }

  async saveStockAdded(event) {
    event.preventDefault();
    let closeModal = this.closeModal;

    if (this.state.qtyAdded) {
      let data = {
        focus: this.props.focus,
        focus_id: this.props.focusObj.token,
        product: this.props.product,
        patch_mode: "add",
        qty_added: this.state.qtyAdded,
      };

      this.setState({
        processing: true,
      });

      let response = await Ajax.patchData(
        domain + "/en/api/shop/v1/stock/",
        data
      );

      if (response) {
        if (response.status === 200) {
          this.setState({
            stockAddSuccessful: true,
            processing: false,
          });

          setTimeout(function () {
            closeModal();
          }, 2000);
        }
      } else {
        this.setState({
          processing: false,
          stockAddFailed: true,
        });
      }
    }
  }

  componentDidMount() {
    console.log(this.props);
    this.qtyAddedInput.current.focus();
  }

  render() {
    let processing = "";
    if (this.state.processing) {
      processing = "is-loading";
    }

    return (
      <div>
        <Helmet>
          <link rel="icon" href={logo} />
          <title>Add Stock | VehShop</title>
        </Helmet>
        <div className="modal is-active animated zoomIn">
          <div className="modal-background"></div>
          <div className="modal-card">
            <header className="modal-card-head">
              <p className="modal-card-title">Add Stock</p>

              <div className="mr-2">
                <Link to="/myshop/home/">
                  <button
                    ref={this.closeAddStockModalBtn}
                    className="delete"
                    aria-label="close"
                  ></button>
                </Link>
              </div>
            </header>
            <section className="modal-card-body">
              {this.props.product ? (
                <div>
                  <div className="has-text-centered is-size-5">
                    <strong>{this.props.product.item.name}</strong>
                  </div>

                  <div className="d-flex justify-content-between is-size-5">
                    <div className="has-text-success">
                      {this.props.product.shop.currency}{" "}
                      {this.props.product.item.price}
                    </div>

                    <div className="has-text-link">
                      {this.state.stockAddSuccessful ? (
                        <span>
                          {this.props.product.item.stock +
                            Number(this.state.qtyAdded)}
                        </span>
                      ) : (
                        <span>{this.props.product.item.stock}</span>
                      )}{" "}
                      {this.props.product.item.unit}
                    </div>
                  </div>
                  <br />

                  {this.state.stockAddSuccessful ? (
                    <div className="message is-success animated fadeIn">
                      <div className="message-body">
                        <div className="is-size-4 has-text-centered">
                          <span className="zmdi zmdi-check-circle"></span>
                        </div>
                        <div className="is-size-4 has-text-centered mt-2">
                          Success
                        </div>
                      </div>
                    </div>
                  ) : (
                    <form action="#" onSubmit={this.saveStockAdded}>
                      {this.state.stockAddFailed ? (
                        <div className="message is-danger">
                          <div className="message-body">
                            <div className="is-size-6">
                              <span className="zmdi zmdi-close-circle"></span>{" "}
                              Error
                            </div>
                            <div>
                              Sorry an Error Occured. Please try again later
                            </div>
                          </div>
                        </div>
                      ) : (
                        <div></div>
                      )}
                      <div>
                        <input
                          ref={this.qtyAddedInput}
                          type="number"
                          className="input"
                          value={this.state.qtyAdded}
                          onChange={(event) => {
                            this.setState({
                              qtyAdded: event.target.value,
                            });
                          }}
                        />
                      </div>

                      <div>
                        <button className="is-hidden"></button>
                      </div>
                    </form>
                  )}
                </div>
              ) : (
                <div>
                  <Loading />
                </div>
              )}
            </section>
            <footer className="modal-card-foot d-flex justify-content-between">
              <Link to="/myshop/home/">
                <button className="button">Cancel</button>
              </Link>
              <button
                onClick={this.saveStockAdded}
                className={"button is-success " + processing}
              >
                Save
              </button>
            </footer>
          </div>
        </div>
      </div>
    );
  }
}

export default AddStock;
